import { render, staticRenderFns } from "./ContactAddress.vue?vue&type=template&id=22561dc0&"
import script from "./ContactAddress.vue?vue&type=script&lang=js&"
export * from "./ContactAddress.vue?vue&type=script&lang=js&"
import style0 from "./ContactAddress.vue?vue&type=style&index=0&id=22561dc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports